import React from 'react'

const People = () => {
  return (
    <>
      <section>
        <h1>People</h1>
      </section> 
    </>
  )
}

export default People
